import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Distributor',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Distributor',
        href: '/adm/distributor',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_distributor',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'dist_code',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'dist_name',
        label: 'Name',
        sortable: true,
      },
      {
        key: 'dist_company',
        label: 'ID Distributor',
        sortable: true,
      },
      {
        key: 'nama_toko',
        label: 'Nama Toko',
        sortable: true,
      },
      {
        key: 'dist_phone',
        label: 'Phone',
      },
      {
        key: 'zonasi',
        label: 'Zonasi',
      },
      {
        key: 'member',
        label: 'Member',
      },
      {
        key: 'pabrik',
        label: 'Pabrik',
      },
      {
        key: 'dist_status',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
    province: [],
    cities: [],
    districts: [],
    villages: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeDistributor(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchDistributor(context, params = null) {
    let result = await ApiGetRequest(`distributor`, params);
    return !result.error ? result.data.object : [];
  },

  async getListDistributor({ commit, state }) {
    commit('changeDistributor', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`distributor`, params);
    commit('changeDistributor', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getPabrik({ commit }, payload = null) {
    commit('changeDistributor', {
      loading: true,
    });

    let result = await ApiGetRequest(`pabrik`, payload);
    commit('changeDistributor', {
      pabrik: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getProvince({ commit }, payload = null) {
    commit('changeDistributor', {
      loading: true,
    });

    let result = await ApiGetRequest(`indo/province`, payload);
    commit('changeDistributor', {
      province: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getCities({ commit }, payload = null) {
    commit('changeDistributor', {
      loading: true,
    });

    let result = await ApiGetRequest(`indo/city`, payload);
    commit('changeDistributor', {
      cities: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDistricts({ commit }, payload = null) {
    commit('changeDistributor', {
      loading: true,
    });

    let result = await ApiGetRequest(`indo/district`, payload);
    commit('changeDistributor', {
      districts: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getVillages({ commit }, payload = null) {
    commit('changeDistributor', {
      loading: true,
    });

    let result = await ApiGetRequest(`indo/village`, payload);
    commit('changeDistributor', {
      villages: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailDistributor({ commit }, payload = null) {
    commit('changeDistributor', {
      loading: true,
    });

    let result = await ApiGetRequest(`distributor/${payload.id}`);
    commit('changeDistributor', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeDistributor', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`distributor/import`, {
      items: data.import_form || [],
    });

    commit('changeDistributor', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async verificationDistributor({ commit }, payload = null) {
    commit('changeDistributor', {
      loading: true,
    });

    let result = await ApiPostRequest(`auth/verification`, {
      credential: payload,
    });

    commit('changeDistributor', {
      loading: false,
    });
    return result.error ? false : true;
  },

  async createDistributor({ commit, state, dispatch }) {
    commit('changeDistributor', {
      loading: true,
    });

    let result = await ApiPostRequest(`distributor`, state.data.form);
    commit('changeDistributor', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateDistributor({ commit, state, dispatch }, payload = null) {
    commit('changeDistributor', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `distributor/${payload.id}`,
      state.data.form
    );

    commit('changeDistributor', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteDistributor({ commit, dispatch }, payload = null) {
    commit('changeDistributor', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`distributor/${payload.id}`);
    commit('changeDistributor', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
